<template>
    <div
        class="switch-button-container"
        :class="{ 'switch-button-container-compact': compact }"
        tabindex="0"
        role="switch"
        :aria-checked="val"
        :aria-disabled="disabled"
        @keydown="keyToggle"
        @click.stop
    >
        <div class="switch-button-control">
            <div class="switch-button" :class="{ enabled: val }" @click="toggle">
                <div class="button"></div>
            </div>
        </div>
        <div v-if="!compact && $slots.default" class="switch-button-label">
            <slot></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
defineOptions({ name: "ToggleSwitch" });

const val = defineModel<boolean>("val");

const { disabled = false, compact = false } = defineProps<{
    disabled?: boolean;
    compact?: boolean;
}>();

const toggle = () => {
    if (disabled) {
        return;
    }
    val.value = !val.value;
};

const keyToggle = (e: KeyboardEvent) => {
    if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        toggle();
    }
    e.stopPropagation();
};
</script>
